import { createActionCreator } from '../../utils/helpers';

import {
  updateMatchStatus,
  OPEN_UPDATE_MATCH_STATUS_MODAL,
  CLOSE_UPDATE_MATCH_STATUS_MODAL,
  REQUEST_OFFER_UPLOAD,
  REQUEST_OFFER_UPLOAD_SUCCESS,
  REQUEST_OFFER_UPLOAD_FAILURE,
  REQUEST_OFFER_UPLOAD_PROGRESS,
  REQUEST_REMOVE_OFFER_DOCUMENT,
  REQUEST_REMOVE_OFFER_DOCUMENT_SUCCESS,
} from './types';

export const requestUpdateMatchStatus = createActionCreator(
  updateMatchStatus.request,
  'fundingSearchId',
  'fundingMatchId',
  'payload',
);
export const requestUpdateMatchStatusSuccess = createActionCreator(
  updateMatchStatus.success,
  'response',
);
export const requestUpdateMatchStatusFailure = createActionCreator(
  updateMatchStatus.failure,
  'error',
);

export const openUpdateMatchStatusModal = createActionCreator(
  OPEN_UPDATE_MATCH_STATUS_MODAL,
  'fundingSearchId',
  'fundingMatchId',
  'status',
);
export const closeUpdateMatchStatusModal = createActionCreator(CLOSE_UPDATE_MATCH_STATUS_MODAL);

export const requestOfferUpload = createActionCreator(
  REQUEST_OFFER_UPLOAD,
  'fundingMatchId',
  'files',
);
export const requestOfferUploadSuccess = createActionCreator(
  REQUEST_OFFER_UPLOAD_SUCCESS,
  'documents',
);
export const requestOfferUploadFailure = createActionCreator(REQUEST_OFFER_UPLOAD_FAILURE, 'error');
export const requestOfferUploadProgress = createActionCreator(
  REQUEST_OFFER_UPLOAD_PROGRESS,
  'progress',
);

export const requestRemoveOffer = createActionCreator(
  REQUEST_REMOVE_OFFER_DOCUMENT,
  'fundingMatchId',
  'documentId',
);
export const requestRemoveOfferSuccess = createActionCreator(
  REQUEST_REMOVE_OFFER_DOCUMENT_SUCCESS,
  'documentId',
);
